require('./contractEasyLoanSuccessStep.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKMessage } = require('commonsComponents/OKMessage');
//@utilities
const { recordLinkV2 } = require('utilities/tagging');
const { decimalsLength, getFormattedString, formatNumber } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

//@constants
const { PERCENTAGE_SYMBOL } = require('constants/index');
    //@analytics
const {
    analyticsId,
    catalogue,
} = require('../analytics/contractEasyLoan.tracking');

class ContractEasyLoanSuccessStep extends React.Component {
    componentDidMount() {
        recordLinkV2(
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_3_SUCCESS]()
        );
    }
    componentWillUnmount() {
        const { onLeave } = this.props;
        onLeave();
    }
    buildList() {
        const { immContractEasyLoan } = this.props;

        const immOpeningCommission = immContractEasyLoan.get('openingCommission');
        const openingCommissionAmount = immOpeningCommission.get('amount');
        const showBothCommissions = immOpeningCommission.get('showPercentajeCommission') && immOpeningCommission.get('showMinCommission');

        let openingCommissionLabel;

        if (showBothCommissions) {
            const openingCommissionMinAmount = immOpeningCommission.get('minimum');
            const decimalLengthOpeningCommissionMin = decimalsLength(openingCommissionMinAmount);
            const openingCommissionMinFormatted = getFormattedString({
                amount: openingCommissionMinAmount,
                currency: immContractEasyLoan.get('currency'),
                decimalsLength: decimalLengthOpeningCommissionMin
            });

            const openingCommissionPercentage = formatNumber(immOpeningCommission.get('percentage'));

            openingCommissionLabel = [
                formatText('contractEasyLoanSidebar-openingCommissionWithPercentaje', [openingCommissionPercentage]),
                formatText('contractEasyLoanSidebar-openingCommissionMin', [openingCommissionMinFormatted])
            ];

        } else if (immOpeningCommission.get('showPercentajeCommission')) {
            const openingCommissionPercentage = formatNumber(immOpeningCommission.get('percentage'));
            openingCommissionLabel = formatText('contractEasyLoanSidebar-openingCommissionWithPercentaje', [openingCommissionPercentage]);
        } else {
            openingCommissionLabel = formatText('contractEasyLoanSidebar-openingCommission');
        }

        const decimalLength = decimalsLength(openingCommissionAmount);

        const fields = [
            {
                title: formatText('contractEasyLoanSuccess-loanImport'),
                bodyText: getFormattedString({
                    amount: immContractEasyLoan.get('selectedAmount'),
                    decimalsLength: 0,
                    currency: immContractEasyLoan.get('currency')
                })
            },
            {
                title: formatText('contractEasyLoan-anualTin'),
                bodyText: this.formatInterest(immContractEasyLoan.get('tin'))
            },
            {
                title: formatText('contractEasyLoanSuccess-term'),
                bodyText: formatText('contractEasyLoan-termMonths', [immContractEasyLoan.get('selectedTerm')])
            },
            {
                title: formatText('contractEasyLoan-TAE'),
                bodyText: this.formatInterest(immContractEasyLoan.get('tae'))
            },
            {
                title: formatText('contractEasyLoan-monthlyInstallment'),
                bodyText: getFormattedString(immContractEasyLoan.get('installment'))
            },
            {
                title: openingCommissionLabel,
                bodyText: getFormattedString({
                    amount: openingCommissionAmount,
                    currency: immContractEasyLoan.get('currency'),
                    decimalsLength: decimalLength
                })
            }
        ];

        return fields.map((field, index) => {
            return (
                <OKInformativeListItem
                    key={field.title + index}
                    title={field.title}
                    bodyText={field.bodyText}
                />
            );
        });
    }

    formatInterest(value) {
        return value.toString().replace(/\./, ',').concat(' ', PERCENTAGE_SYMBOL);
    }

    render() {
        let informativeMessage = null;
        let informativeMessage2 = null;

        const { immAccount, email, immContractEasyLoan } = this.props;
        const title = formatText('contractEasyLoanSuccess-title');
        const accountAlias = immAccount.get('alias');
        const accountIBAN = getLastNChars(immAccount.get('iban'));
        const subMessage = (
            <span>
                <FormattedText value="contractEasyLoanSuccess-subMessage" />
                <span className="contract-easy-loan-success-step__account">
                    {`${accountAlias} ${accountIBAN}`}
                </span>
            </span>
        );

        const listItems = this.buildList();

        const goToAccounts = {
            label: formatText('contractEasyLoanSuccess-goToAccounts').toUpperCase(),
            url: 'myprofile/accounts'
        };

        const goToLoanMortgages = {
            label: formatText('contractEasyLoanSuccess-goToLoansAndMortgages').toUpperCase(),
            url: '/myprofile/loans-mortgages',
            onLinkClick: () => recordLinkV2(catalogue[analyticsId.CLICK_BREADCRUMB_01]()),
        };

        //validate the message to be used when the user has an email available
        if (email) {
            informativeMessage = (
                <FormattedText
                    injectedStrings={[ email ]}
                    noWrapper
                    value="contractEasyLoanSuccess-informativeMessage"
                />
            );
            informativeMessage2 = (
                <FormattedText
                    noWrapper
                    value="contractEasyLoanSuccess-informativeMessage2"
                />
            );
        }
        else {
            informativeMessage = (
                <FormattedText
                    noWrapper
                    value="contractEasyLoanSuccess-informativeEmailWithOutEmail"
                />
            );
            informativeMessage2 = (
                <FormattedText
                    noWrapper
                    value="contractEasyLoanSuccess-informativeEmailWithOutEmail2"
                />
            );
        }

        return (
            <article className="contract-easy-loan-success-step row no-gutter">
                <div className="col-xs-offset-1 col-xs-9">
                    <WizardSuccess
                        successMessage={title}
                        successSubMessage={subMessage}
                        mainButton={goToAccounts}
                        secondaryButton={goToLoanMortgages}
                        secondaryButtonStyle="link-complementary"
                        tealium={catalogue[analyticsId.CONTRACT_EASY_LOAN_WIZARD_SUCCESS]({
                            data: immContractEasyLoan.get("minTae")
                        })}
                        isSecondVersion
                    >
                        <div className="contract-easy-loan-success-step__separator" />
                        <OKInformativeList columns={2}>
                            {listItems}
                        </OKInformativeList>
                        { __CONTACT_CENTER__ && !isPrintOfficeMode() && <OKMessage type="informative">
                            <div>{informativeMessage}</div>
                            <div>{informativeMessage2}</div>
                        </OKMessage>
                        }
                    </WizardSuccess>
                </div>
            </article>
        );
    }
}

ContractEasyLoanSuccessStep.propTypes = {
    immContractEasyLoan: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    email: PropTypes.string
};

module.exports = ContractEasyLoanSuccessStep;
